import { useScheduleNotificationBanner } from './hooks';
import { StressAssessmentScheduleNotificationBannerPresentation } from './presentations';

export const StressAssessmentScheduleNotificationBanner: React.FC = () => {
  const { isVisible, onClose } = useScheduleNotificationBanner();

  if (!isVisible) return null;

  return <StressAssessmentScheduleNotificationBannerPresentation onClose={onClose} />;
};
